import { render } from "./ShimmerFile.vue?vue&type=template&id=51a9fa84"
import script from "./ShimmerFile.vue?vue&type=script&lang=js"
export * from "./ShimmerFile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__